import { Drawer } from '@revenuewell/ui-drawers';
import { FC, PropsWithChildren } from 'react';

import { ContentTitle } from './content-title';
import { PaymentsDrawer } from './payments-drawer';
import { ContentArea, ShellRoot } from './payments-shell.styles';

interface PaymentsShellProps {
  title: string;
}

export const PaymentsShell: FC<PropsWithChildren<PaymentsShellProps>> = ({ children, title }) => (
  <ShellRoot>
    <Drawer>
      <PaymentsDrawer />
    </Drawer>
    <ContentArea>
      <ContentTitle title={title} />
      {children}
    </ContentArea>
  </ShellRoot>
);
